<template>
  <div class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h3>设置</h3>
        <button class="close-btn" @click="closeModal">×</button>
      </div>
      <div class="modal-body">
        <div class="settings-section">
          <h4>任务类型管理</h4>
          <div class="settings-list">
            <div v-for="type in store.types" :key="type.id" class="settings-item">
              <span>{{ type.name }}</span>
              <div class="item-actions">
                <button class="btn-icon" @click="editType(type)">
                  <i class="icon">✏️</i>
                </button>
                <button class="btn-icon danger" @click="deleteType(type.id)">
                  <i class="icon">🗑️</i>
                </button>
              </div>
            </div>
          </div>
          <div class="add-form">
            <input v-model="newType" type="text" placeholder="新增任务类型" @keyup.enter="addType" />
            <button class="btn small" @click="addType">添加</button>
          </div>
        </div>

        <div class="settings-section">
          <h4>任务周期管理</h4>
          <div class="settings-list">
            <div v-for="cycle in store.cycles" :key="cycle.id" class="settings-item">
              <span>{{ cycle.name }}</span>
              <div class="item-actions">
                <button class="btn-icon" @click="editCycle(cycle)">
                  <i class="icon">✏️</i>
                </button>
                <button class="btn-icon danger" @click="deleteCycle(cycle.id)">
                  <i class="icon">🗑️</i>
                </button>
              </div>
            </div>
          </div>
          <div class="add-form">
            <input v-model="newCycle" type="text" placeholder="新增任务周期" @keyup.enter="addCycle" />
            <button class="btn small" @click="addCycle">添加</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useTodoStore } from '../stores/todoStore.js'
import TodoService from '@/services/todoService.js'

export default {
  name: 'SettingsModal',
  emits: ['close'],
  setup(props, { emit }) {
    const store = useTodoStore()

    const newType = ref('')
    const newCycle = ref('')

    const closeModal = () => {
      emit('close')
    }

    const addType = async () => {
      if (newType.value.trim()) {
        try {
          const data = {
            name: newType.value,
            modal_type: 'type'
          }

          const response = await TodoService.addTodoTypeOrCycle(data)
          if (response.status === 'ok') {
            // 更新store中的类型列表
            store.updateTypes([...store.types, { id: response.id, name: response.name }])
            newType.value = ''
            console.log('任务类型添加成功')
          } else {
            console.error('任务类型添加失败:', response.message)
          }
        } catch (error) {
          console.error('添加任务类型失败:', error)
        }
      }
    }

    const addCycle = async () => {
      if (newCycle.value.trim()) {
        try {
          const data = {
            name: newCycle.value,
            modal_type: 'cycle'
          }

          const response = await TodoService.addTodoTypeOrCycle(data)
          if (response.status === 'ok') {
            // 更新store中的周期列表
            store.updateCycles([...store.cycles, { id: response.id, name: response.name }])
            newCycle.value = ''
            console.log('任务周期添加成功')
          } else {
            console.error('任务周期添加失败:', response.message)
          }
        } catch (error) {
          console.error('添加任务周期失败:', error)
        }
      }
    }

    const editType = async (type) => {
      // 这里应该打开编辑对话框或直接编辑
      const newName = prompt('请输入新的类型名称:', type.name)
      if (newName && newName !== type.name) {
        try {
          const data = {
            id: type.id,
            name: newName,
            modal_type: 'type'
          }

          const response = await TodoService.updateTodoTypeOrCycle(data)
          if (response.status === 'ok') {
            // 更新store中的类型列表
            const updatedTypes = store.types.map(t =>
              t.id === type.id ? { ...t, name: newName } : t
            )
            store.updateTypes(updatedTypes)
            console.log('任务类型更新成功')
          } else {
            console.error('任务类型更新失败:', response.message)
          }
        } catch (error) {
          console.error('更新任务类型失败:', error)
        }
      }
    }

    const editCycle = async (cycle) => {
      // 这里应该打开编辑对话框或直接编辑
      const newName = prompt('请输入新的周期名称:', cycle.name)
      if (newName && newName !== cycle.name) {
        try {
          const data = {
            id: cycle.id,
            name: newName,
            modal_type: 'cycle'
          }

          const response = await TodoService.updateTodoTypeOrCycle(data)
          if (response.status === 'ok') {
            // 更新store中的周期列表
            const updatedCycles = store.cycles.map(c =>
              c.id === cycle.id ? { ...c, name: newName } : c
            )
            store.updateCycles(updatedCycles)
            console.log('任务周期更新成功')
          } else {
            console.error('任务周期更新失败:', response.message)
          }
        } catch (error) {
          console.error('更新任务周期失败:', error)
        }
      }
    }

    const deleteType = async (typeId) => {
      if (confirm('确定要删除这个任务类型吗？')) {
        try {
          const data = {
            id: typeId,
            modal_type: 'type'
          }

          const response = await TodoService.deleteTodoTypeOrCycle(data)
          if (response.status === 'ok') {
            // 更新store中的类型列表
            const updatedTypes = store.types.filter(t => t.id !== typeId)
            store.updateTypes(updatedTypes)
            console.log('任务类型删除成功')
          } else {
            console.error('任务类型删除失败:', response.message)
          }
        } catch (error) {
          console.error('删除任务类型失败:', error)
        }
      }
    }

    const deleteCycle = async (cycleId) => {
      if (confirm('确定要删除这个任务周期吗？')) {
        try {
          const data = {
            id: cycleId,
            modal_type: 'cycle'
          }

          const response = await TodoService.deleteTodoTypeOrCycle(data)
          if (response.status === 'ok') {
            // 更新store中的周期列表
            const updatedCycles = store.cycles.filter(c => c.id !== cycleId)
            store.updateCycles(updatedCycles)
            console.log('任务周期删除成功')
          } else {
            console.error('任务周期删除失败:', response.message)
          }
        } catch (error) {
          console.error('删除任务周期失败:', error)
        }
      }
    }

    return {
      store,
      newType,
      newCycle,
      closeModal,
      addType,
      addCycle,
      editType,
      editCycle,
      deleteType,
      deleteCycle
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
}

.settings-section {
  margin-bottom: 30px;
}

.settings-section h4 {
  margin: 0 0 15px 0;
  font-size: 18px;
  color: #333;
}

.settings-list {
  border: 1px solid #eee;
  border-radius: 8px;
  margin-bottom: 15px;
  max-height: 200px;
  overflow-y: auto;
}

.settings-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid #eee;
}

.settings-item:last-child {
  border-bottom: none;
}

.item-actions {
  display: flex;
  gap: 8px;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  transition: background 0.3s ease;
}

.btn-icon:hover {
  background: #f0f0f0;
}

.btn-icon.danger:hover {
  background: #ffebee;
}

.add-form {
  display: flex;
  gap: 10px;
}

.add-form input {
  flex: 1;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn.small {
  padding: 8px 15px;
  font-size: 14px;
}

.btn.primary {
  background: #42b983;
  color: white;
}

.btn.primary:hover {
  background: #359c6d;
}

.btn.secondary {
  background: #f0f0f0;
  color: #333;
}

.btn.secondary:hover {
  background: #e0e0e0;
}
</style>